import momentGenerateConfig from "rc-picker/es/generate/moment";
import generateCalendar from './generateCalendar';
var Calendar = generateCalendar(momentGenerateConfig);
export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/es/calendar/index.js
// module id = 1683
// module chunks = 0